const WIDGET_ID = "result-top-trend-keywords";

export { WIDGET_ID };
